import React from "react";

const HistoryModal = ({ isOpen, setOpen, data }) => {
  if (!isOpen) return null;

  // console.log(">>>>>>>>>>>>>", data);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-gray-800 p-6 w-[available] rounded-lg shadow-lg  ">
        <div className="w-full justify-content-between d-flex">
          <p className="text-sm text-white font-semibold">History</p>
          <button
            className=" text-gray-500"
            onClick={() => {
              setOpen(!isOpen);
            }}
          >
            ✖
          </button>
        </div>

        <div>
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-white">
              <thead className="text-xs text-white uppercase bg-gray-700 ">
                <tr>
                  
                  <th scope="col" className="px-6 py-3">
                    User Name
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Win Amount
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Bet Amount
                  </th>
                </tr>
              </thead>
              <tbody>
             
                {data?.map((d, index) => (
                  <tr
                    key={index}
                    className="odd:bg-gray-800  even:bg-gray-800  border-b"
                  >
                   
                    <td className="px-3 py-2">{d.username}</td>
                    <td className="px-3 py-2">{d.winAmount?.toFixed(2)}</td>
                    <td className="px-3 py-2">{d.betAmount?.toFixed(2)}</td>
                  </tr>
                ))}

                {/* <tr className="odd:bg-white  even:bg-gray-700 e border-b  border-gray-200">
                  <th
                    scope="row"
                    className="px-3 py-2 font-medium text-white whitespace-nowrap "
                  >
                    Google Pixel Phone
                  </th>
                  <td className="px-3 py-2">Gray</td>
                  <td className="px-3 py-2">Phone</td>
                  <td className="px-3 py-2">$799</td>
                </tr> */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryModal;
